(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('paie', {
            parent: 'gestion',
            url: '/paie?page&sort&search&technicien&datePaie&datePrime',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.paie.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/paie/paies.html',
                    controller: 'PaieController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                technicien: null,
                datePaie: null,
                datePrime: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        technicien: $stateParams.technicien,
                        datePaie: $stateParams.datePaie,
                        datePrime: $stateParams.datePrime,
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('paie');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('paie-detail', {
            parent: 'paie',
            url: '/paie/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.paie.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/paie/paie-detail.html',
                    controller: 'PaieDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('paie');
                    $translatePartialLoader.addPart('conges');
                    $translatePartialLoader.addPart('astreinte');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Paie', function($stateParams, Paie) {
                    return Paie.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'paie',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('paie-detail.edit', {
            parent: 'paie-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/paie/paie-dialog.html',
                    controller: 'PaieDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Paie', function(Paie) {
                            return Paie.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('paie.new', {
            parent: 'paie',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/paie/paie-dialog.html',
                    controller: 'PaieDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                month: null,
                                technicien: null,
                                activity: null,
                                pointChefMonome: null,
                                pointChefBinome: null,
                                pointSupportBinome: null,
                                monthPrime: null,
                                totalPoint: null,
                                primeRendement: null,
                                primeExceptionnelle: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('paie', null, { reload: 'paie' });
                }, function() {
                    $state.go('paie');
                });
            }]
        })
        .state('paie.edit', {
            parent: 'paie',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/paie/paie-dialog.html',
                    controller: 'PaieDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Paie', function(Paie) {
                            return Paie.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('paie', null, { reload: 'paie' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('paie.delete', {
            parent: 'paie',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/paie/paie-delete-dialog.html',
                    controller: 'PaieDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Paie', function(Paie) {
                            return Paie.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('paie', null, { reload: 'paie' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
